module.exports = __webpack_public_path__ + "media/images/samples/300x300/12-1c7c4147fcb7901877e907e92e2696df.jpg";